import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { push } from 'connected-react-router'
import { useDispatch } from 'react-redux'

type Props = {
  isPrimary?: boolean
  label: string
  url: string
}

const MenuCard: FC<Props> = (props) => {
  const { isPrimary, label, url } = props

  const dispatch = useDispatch()

  const className = isPrimary ? styles.menu__base_primary : styles.menu__base

  return (
    <a className={className} role={'button'} onClick={() => dispatch(push(url))}>
      <h2>{label}</h2>
    </a>
  )
}

export default MenuCard
